export default __webpack_public_path__ + "static/media/Groupe1.10a2ec8c.png";